// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___bH89W","flex":"flex___29NuA","label":"label___3xTIe","full":"full___2Ir5H"};